export enum OrderStatusEnum {
  CANCELED = 'CANCELED',
  PARTIALLY_DISPATCH = 'PARTIALLY_DISPATCH',
  IN_PREPARATION = 'IN_PREPARATION',
  VALIDATED = 'VALIDATED',
  CANCELLED = 'CANCELLED',
  DELETED = 'DELETED',
  PARTIALLY_SHIPPED_CANCELLED = 'PARTIALLY_SHIPPED_CANCELLED',
  SHIPPED = 'SHIPPED',
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING'
}
